<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>


        <div style="width:100%; box-sizing:border-box; margin:0px auto; display:block;">

            <GrcText ref="txtEmailCim"
            grc_ispassword="false"
            grc_labeltext="E-mail cím:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:20px;"
            grc_canshowpassword="mobilapp"
            />

            <GrcText ref="txtTelefon"
            grc_ispassword="false"
            grc_labeltext="Telefonszám:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:20px;"
            grc_canshowpassword="mobilapp"
            />

            <table style="width:100%; margin-bottom:30px;" cellspacing="0" cellpadding="0">
            <tr>
                <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkSzamlaMozgas" /></td>
                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:16px; line-height:21px; color:#222;">
                    Automatikus e-mail értesítőt kérek a számla mozgásokról
                </td>
            </tr>
            </table>

            <table style="width:100%; margin-bottom:30px;" cellspacing="0" cellpadding="0">
            <tr>
                <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkHirlevel" /></td>
                <td valign="top" style="text-align:left; font-family:'CmsDefault'; font-size:16px; line-height:21px; color:#222;">
                    Feliratkozom a Pénztár elektronikus hírlevél szolgáltatására
                </td>
            </tr>
            </table>

            <div style="width:100%; box-sizing:border-box; text-align:center;">

                <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="btnOK_click">
                    <span><i class="fal fa-check" style="margin-right:10px;"></i>Rendben</span>
                </span>

                <span class="cms_linkbutton cms_linkbutton_CANCEL" style="margin: 4px 8px;" @click="btnMegsem_click">
                    <span><i class="fal fa-times" style="margin-right:10px;"></i>Mégsem</span>
                </span>

            </div>   

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'

export default {
  name: 'frmertesitesbeallitas',
  components: {
      GrcDB,
      GrcDialog,
      GrcText,
      GrcNum,
      GrcCheckboxMobile
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmErtesitesBeallitas_",

      }
  },
  model: {

  },  
  methods:{



    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmErtesitesBeallitas_", pCompName);
    },

    SetLang()
    {
        this.HideErrors();
        this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click(e)
      {
        this.Mentes();
      },

      btnMegsem_click(e)
      {
        document.location = "dashboard";
      },

      HideErrors()
      {
        this.$refs.txtEmailCim.HideError();
      },


      async Init()
      {
        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.$refs.txtEmailCim.SetText(Q.RESULT[0].EmailCim);
        this.$refs.txtTelefon.SetText(Q.RESULT[0].Telefon);
        this.$refs.chkSzamlaMozgas.SetValue(Q.RESULT[0].SzamlaMozgas);
        this.$refs.chkHirlevel.SetValue(Q.RESULT[0].Hirlevel);

      },



      async Mentes()
      {
        this.HideErrors();

        var ErrorCompName = "";

        if ((this.$refs.chkSzamlaMozgas.GetValue() == 1)&&(this.$refs.txtEmailCim.GetText().trim() == ""))
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          this.$refs.txtEmailCim.ShowError("Ha feliratkozik értesítő szolgáltatásra, az e-mail cím megadása kötelező!");
        }

        if ((this.$refs.chkHirlevel.GetValue() == 1)&&(this.$refs.txtEmailCim.GetText().trim() == ""))
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          this.$refs.txtEmailCim.ShowError("Ha feliratkozik értesítő szolgáltatásra, az e-mail cím megadása kötelező!");
        }

        if (this.$refs.txtEmailCim.GetText().trim() != "")
        {
            if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
            {
            if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
            this.$refs.txtEmailCim.ShowError("Az e-mail cím helytelen!");
            }
        }


        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]",
            sEmailCim: this.$refs.txtEmailCim.GetText().trim(),
            sTelefon: this.$refs.txtTelefon.GetText().trim(),
            iSzamlaMozgas: this.$refs.chkSzamlaMozgas.GetValue(),
            iHirlevel: this.$refs.chkHirlevel.GetValue()
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Mentes", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        await this.ShowInfo(Q.RESULT[0].strResult, 200);

        if (Q.RESULT[0].intResult == 1)
        {
            document.location = "dashboard";
        }

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },





  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();
  }

}


</script>


<style scoped>




</style>